/* Controllers */
angular.module('LexiconControllers')

  .controller('LexiconHomeCtrl', ['$scope', 'lexicon', 'api', '$mdDialog', function($scope, lexicon, api, $mdDialog) {
    // Add word to user's lexicon
    $scope.word = {
      word: ""
    };
    $scope.lexicon = [];

    api.sync(api.getWords);
    
    $scope.$watch(function() {
      return api.data.words;
    }, function(newVal, oldVal) {
      $scope.lexicon = newVal
    }, true);

    // Delete word to user's lexicon : action from the list
    $scope.deleteWord = function(word, index, ev) {
      var confirm = $mdDialog.confirm({
        preserveScope: true,
        parent: angular.element(document.body),
      })
        .title(word.word)
        .textContent('Souhaitez-vous retirer ce mot de votre glossaire ?')
        .ariaLabel('Delete word')
        .clickOutsideToClose(true)
        .targetEvent(ev)
        .ok('Confirmer')
        .cancel('Annuler');

      $mdDialog.show(confirm).then(function() {
        lexicon.removeWord(word.text);
      });
    };

    $scope.showWord = function(word) {
      lexicon.showWordBottom(word);
    };
  }
  ]);
